// $(document).ready(function () {
//     $(window).on("load resize", function () {
//     if ($(window).width() > 768) {
        
        
//         const items = document.querySelectorAll(".product-ingredients-section .circle .item");
//         const total = items.length;
        
//         const baseRadius = document.querySelector(".product-ingredients-section .circle").offsetWidth / 2;
//         const radius = baseRadius + 10;           // your original extra 10
//         let extraOffset = 40;                   // ⬅ push outside
//          if ($(window).width() > 1300) {
//             extraOffset = 70; 
//          }
//         const itemSize = document.querySelector(".product-ingredients-section .circle .item").offsetWidth;
//         const startAngle = -60;
        
//         // items.forEach((item, i) => {
//         //     const angle = ((i / total) * 360 + startAngle) * (Math.PI / 180);
            
//         //     // add extraOffset outward
//         //     const x = Math.cos(angle) * (radius + extraOffset) - itemSize / 2;
//         //     const y = Math.sin(angle) * (radius + extraOffset) - itemSize / 2;
            
//         //     item.style.transform = `translate(${x}px, ${y}px)`;
//         // });
        
//         items.forEach((item, i) => {
//             const angle = ((i / total) * 360 + startAngle) * (Math.PI / 180);
//       let len=$(items).length
//             const w = item.offsetWidth;
//             const h = item.offsetHeight;

//             const x = Math.cos(angle) * (radius + extraOffset) - w / 2;
//             const y = Math.sin(angle) * (radius + extraOffset) - h / 2;
//             if (len==6 && (i==1 || i==4)) {
//                 item.style.top="50%";
//             }
//             // $(item).addClass(`top-${l}`)

//             item.style.transform = `translate(${x}px, ${y}px)`;
//         });


//     }
// })
// });
function positionCircleItems(startAngle = 0, offset = 40) {
    const container = document.querySelector(".product-ingredients-section .circle");
    const items = document.querySelectorAll(".product-ingredients-section .circle .item");
    if ($(".product-ingredients-section .circle .item").length==6) {
        startAngle=-60;
    }
        if ($(window).width() > 1300) {
            offset = 70; 
            if ($(".product-ingredients-section .circle .item").length==4) {
               offset = 30;   
            }
            else if($(".product-ingredients-section .circle .item").length==8){
                // offset = 70;   
                offset = 30;   
            }

         }
    if (!container || items.length === 0) return;

    const radius = (container.offsetWidth / 2) + offset;   // responsive
    const total = items.length;

    items.forEach((item, i) => {
        let rad=radius;
        if($(".product-ingredients-section .circle .item").length==8 && i==0  && i==4){
                // rad=radius-30;
        }
        // angle per item
        const angleDeg = startAngle + (360 / total) * i;
        const angle = angleDeg * Math.PI / 180;

        // calculate position
        const x = rad + Math.cos(angle) * (rad - 20);
        const y = rad + Math.sin(angle) * (rad - 20);

        item.style.left = `${x}px`;
        item.style.top = `${y}px`;
    });
}

// Run on load + on resize
positionCircleItems(-90);   // start top
// window.addEventListener("load resize", () => {
//     let add_class = $(".product-ingredients-section .circle").data("class");
//     console.log("Add class===",add_class);
    
//       if (add_class) {
//         $(".product-ingredients-section .circle").removeClass(add_class);
//     console.log("Add class 11===",add_class);
        
//     }
//     positionCircleItems(-90)
//     if (add_class) {
//         $(".product-ingredients-section .circle").addClass(add_class);
//     console.log("Add class===22",add_class);

//     }
// }
// );window.addEventListener("load", resizeHandler);
window.addEventListener("resize", resizeHandler);
window.addEventListener("load", resizeHandler);
window.addEventListener("resize",addPadding);
window.addEventListener("resize",setHeight);
if (window.innerWidth > 768) {
    addPadding();
    // setHeight()
    
}
else{
    $(".product-ingredients-section").removeAttr("style")
}


function resizeHandler() {
    let add_class = $(".product-ingredients-section .circle").data("class");
    console.log("Add class ===", add_class);

    if (add_class) {
        $(".product-ingredients-section .circle").removeClass(add_class);
        // console.log("Add class 11 ===", add_class);
    }

    positionCircleItems(-90);
    if (add_class) {
        $(".product-ingredients-section .circle").addClass(add_class);
        // console.log("Add class 22 ===", add_class);
    }
    setHeight()
    setTimeout(() => {
        addPadding()
    }, 100);
    
}

function setHeight() {
    let maxHeight=0
    $(".product-ingredients-section .circle .item").css("height","")
    console.log("Height==");
    if ($(".product-ingredients-section .circle .item").length==8) return;
$(".product-ingredients-section .circle .item").each((i,j)=>{
//    console.log("oo", $(j).outerHeight())
    if (maxHeight < $(j).outerHeight()) {
        maxHeight = $(j).outerHeight();
    } {
        
    }
})
$(".product-ingredients-section .circle .item").css("height",maxHeight)
}

// Code for adding extra padding
function addPadding() {
    console.log("Padding added==");
    
    const wrapper = document.querySelector(".product-ingredients-section");
const circle = document.querySelector(".circle");
  const items = document.querySelectorAll(".circle .item");
if (!wrapper && !circle && !items) return;
  const circleRect = circle.getBoundingClientRect();
  const wrapperRect = wrapper.getBoundingClientRect();

  // Circle center
  const cx = circleRect.left - wrapperRect.left + circleRect.width / 2;
  const cy = circleRect.top - wrapperRect.top + circleRect.height / 2;

  const circleRadius = circleRect.width / 2;

  let maxOverflow = 0;

  items.forEach(item => {
    const rect = item.getBoundingClientRect();

    // item center
    const itemCx = rect.left - wrapperRect.left + rect.width / 2;
    const itemCy = rect.top - wrapperRect.top + rect.height / 2;

    // distance from circle center to item center
    const centerDistance = Math.hypot(itemCx - cx, itemCy - cy);

    // distance from item center to its furthest edge
    const itemRadius = Math.max(rect.width, rect.height) / 2;

    // overflow calculation
    const overflow = centerDistance + itemRadius - circleRadius;

    if (overflow > maxOverflow) {
      maxOverflow = overflow;
    }
  });

  // Add a small buffer (optional)
  const buffer = -30;
if (window.innerWidth > 768) {
    wrapper.style.paddingTop = `${Math.ceil(maxOverflow+buffer)/2}px`;
}
else{
    $(".product-ingredients-section").removeAttr("style")
}


}
